import styled from "styled-components";
import { Typography } from "@mui/material";

export const EllipsisText = styled(Typography)`
    overflow: hidden;
    display: -webkit-box;
    font-size ${(props: any): string => props.fontSize ? props.fontSize : '12px'};
    -webkit-box-orient: vertical;
    -webkit-line-clamp ${(props: any): string => props.clamp ? props.clamp : '1'};
`;
